import Media from './Media'
import EventEmitter from 'src/helpers/EventEmitter'
import Raf from 'src/helpers/Raf'

const Events = {
  PROGRESS: 'progress',
  COMPLETED: 'completed',
}

class MediaService {
  constructor() {
    Object.assign(this, EventEmitter)
    this.media = []
    this.updateProgressList = []
    this._progress = 0
    this._muted = false
  }

  // _updateProgress = () => {
  //   let progress = 0
  //   for (const media of this.media) {
  //     // let mediaProgress = 0
  //     // for (const track of media.tracks) {
  //     //   // mediaProgress += track.loading.progress
  //     // }
  //     // let l = this.media.tracks ? this.media.tracks.length : 1
  //     // mediaProgress /= l
  //     let mediaProgress = media.videoLoadProgress
  //     progress += mediaProgress
  //   }
  //   if (this._progress !== progress) {
  //     this.emit(Events.PROGRESS, progress)
  //   }
  //   this._progress = progress
  //   this.rafId = window.requestAnimationFrame(this._updateProgress)
  // }

  _updateProgress = () => {
    let progress = 0
    for (const media of this.media) {
      let mediaProgress = 0
      for (const track of media.tracks) {
        mediaProgress += track.loading.progress // * (1 / media.tracks.length)
      }
      mediaProgress /= media.tracks.length
      progress += mediaProgress
    }
    progress /= this.media.length

    // Emit
    if (this._progress !== progress) {
      this.emit(Events.PROGRESS, progress)
    }
    this._progress = progress
  }

  load = (manifest) => {
    // this.media = []
    this.updateProgressList = []
    this._progress = 0

    // CREATE ELEMENTS
    for (const config of manifest) {
      let media = new Media(config)
      this.media.push(media)
      this.updateProgressList.push(media)
    }

    // UPDATE
    Raf.add(this._updateProgress)
    // this.rafId = window.requestAnimationFrame(this._updateProgress)

    // LOAD
    return new Promise((resolve) => {
      ;(async () => {
        for (let media of this.updateProgressList) {
          await media.load()
        }
        // window.cancelAnimationFrame(this.rafId)
        Raf.remove(this._updateProgress)
        this._progress = 1
        this.emit(Events.PROGRESS, this._progress)
        this.emit(Events.COMPLETED)
        console.log(`MediaService loaded`)
        resolve()
      })()
    })
  }

  get = (id) => {
    return this.media.filter((media) => {
      return media.id === id
    })[0]
  }

  stopAll = () => {
    for (let media of this.media) {
      media.pause()
      media.currentTime = 0
    }
  }

  get progress() {
    return this._progress
  }

  get muted() {
    return this._muted
  }

  set muted(val) {
    this._muted = val
    for (let media of this.media) {
      media.muted = val
    }
  }
}

let service = new MediaService()
service.Events = Events
window.MediaService = service
export default service
